export default __webpack_public_path__ + "static/media/box 1 Light.9900fdb7.svg";